module.exports = __webpack_public_path__ + "static/media/corporate-services-img24.1b706773.jpg";